import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getStockBalance = catchAsync(
  async (
    currentLang,
    companyName = '',
    from_date,
    to_date,
    warehouse = '',
    item_code = '',
    stock_uom = ''
  ) => {
    const { data } = await axiosInstance.get(
      // `/api/method/technoerp.services.get_report?report_name=Stock Balance&filters={"company":"${companyName}","from_date":${from_date},"to_date":${to_date},"valuation_field_type":"Currency"}&_lang=${currentLang}&ignore_prepared_report=true&_=1731064939081`
      `/api/method/technoerp.services.get_report?report_name=Stock Balance&filters={"company":"${companyName}","from_date":"${from_date}","to_date":"${to_date}","valuation_field_type":"Currency","item_code": "${item_code}","stock_uom": "${stock_uom}","warehouse": "${warehouse}"}&_lang=${currentLang}&ignore_prepared_report=true&_=1731064939081`
    );
    return data;
  }
);
